export enum RetryOrReload {
  Retry = 'retry',
  Reload = 'reload',
}
